import { render, staticRenderFns } from "./purchaseProduct.vue?vue&type=template&id=1903b4a4&scoped=true&"
import script from "./purchaseProduct.vue?vue&type=script&lang=js&"
export * from "./purchaseProduct.vue?vue&type=script&lang=js&"
import style0 from "./purchaseProduct.vue?vue&type=style&index=0&id=1903b4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903b4a4",
  null
  
)

export default component.exports